import { useLayoutEffect, useState, type RefObject } from 'react'

/** The element's width through ResizeObserver (spec §4.2): 0 until measured,
 * and always 0 in a layout-less DOM, where the map falls back to
 * MAP_GRID.DEFAULT_COLUMNS. */
export function useContainerWidth(ref: RefObject<HTMLElement | null>): number {
  const [width, setWidth] = useState(0)
  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    setWidth(el.getBoundingClientRect().width)
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width
      if (typeof w === 'number') setWidth(w)
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [ref])
  return width
}
